import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  chapterInitialValues,
  chapterMandatoryFields,
  chapterProperties,
  chapterValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import { CREATE_YEAR } from "utils/graphql/services/entities/mutations";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import LoadingButton from "@mui/lab/LoadingButton";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getAcademicYearListData } from "utils/metadata-split/metaDataApiFetch";
import { CREATE_CHAPTER } from "utils/graphql/services/global-content-hierarchy/mutation";
import { shouldDisableButton } from "pages/global-content-hierarchy/helper";

export const ChapterCreate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    chapterInitialValues,
    chapterValidationSchema,
    ""
  );
  const [createchapter, { loading, error, data }] = useMutation(
    CREATE_CHAPTER,
    {
      client: entitesClient,
    }
  );
  const dispatch = useAppDispatch();
  const history = useHistory();

  const handleCreateChapter = async () => {
    try {
      const response: any = await createchapter({
        variables: {
          input: {
            global_name: watch()?.global_name,
            color_icon_url: watch()?.color_icon_url,
            patch_icon_url: watch()?.patch_icon_url,
            status: watch()?.status,
            chapter_code: watch()?.chapter_code,
            image_url: watch()?.image_url,
          },
        },
      });
      if (!isEmpty(response?.data?.createChapter?.success)) {
        dispatch(
          snackbarRequest({
            message:
              `${response?.data?.createChapter?.message}` ||
              `Created chapter successfully`,
          })
        );
        history.replace(`/global-content-hierarchy/chapter`);
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.message}` || `failed to create chapter`,
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        snackbarRequest({
          message: `${err}` || `failed to create chapter`,
          type: "error",
        })
      );
    }
  };

  return (
    <div>
      <TypographyHeading>Create chapter</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={chapterProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              sx={{
                width: "200px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateChapter}
              disabled={shouldDisableButton(watch(), ["global_name"])}
              loading={loading}
            >
              Create chapter
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
